import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStatusErrorQuickInfo extends Layout {
	labelErrorDescription: Label;
	sourceEdiMapError: DataSource;
	tableErrors: Table;
}
